export default function($) {
  let mobileSwiper = document.querySelector('.js-mobile-swiper');
  let mobileSlidesCount = $('.js-mobile-swiper .swiper-slide').length;
  let initMobileSwiper = false;

  const mobileSwiperParams = {
    lazy: true,
    slidesPerView: 1.2,
    spaceBetween: 24,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      480: {
        slidesPerView: 1.3,
        spaceBetween: 32,
      },
    },
  };

  if( mobileSlidesCount > 1 ) {
    swiperDisplay();

    $(window).resize(function() {
      swiperDisplay();
    })
  }

  function swiperDisplay() {
    if( $(window).width() < 1280 ) {
      if( !initMobileSwiper ) {
        initMobileSwiper = true;

        $('.js-mobile-swiper').each(function(index) {
          let swiperDiv = $(this)[0]
          mobileSwiper = new Swiper(swiperDiv, mobileSwiperParams);
        })
      }
    }

    else {
      if( $('.js-mobile-swiper').length) {
        $('.js-mobile-swiper').each( function() {
          let swiperDiv = $(this)[0]
          if (swiperDiv.swiper) {
            swiperDiv.swiper.destroy(false,true)
          }
        })
        initMobileSwiper = false
      }
    }
  }
}
